import type { BankDetails } from "./types";

const BANK_DETAIL_ROWS: { key: keyof BankDetails; label: string }[] = [
  { key: "bankName", label: "Bank Name" },
  { key: "accountName", label: "Account Name" },
  { key: "accountNumber", label: "Account Number" },
  { key: "branchName", label: "Branch Name" },
  { key: "ifscCode", label: "IFSC Code" },
];

interface InvoicePreviewPaymentSectionProps {
  dueDays: number;
  bankDetails: BankDetails;
}

const InvoicePreviewPaymentSection = ({
  dueDays,
  bankDetails,
}: InvoicePreviewPaymentSectionProps) => {
  return (
    <div className="flex justify-between pt-32 text-xs">
      <div className="text-muted-foreground space-y-2">
        <div>
          <p className="text-foreground font-semibold">Payment Terms</p>
          <p>Due within {dueDays} days.</p>
        </div>
        <div>
          <p className="font-bold text-black">Bank Details</p>
          <div className="mt-1 space-y-0.5 text-black">
            {BANK_DETAIL_ROWS.map(({ key, label }) => (
              <p key={key} className="font-normal">
                {label} : {bankDetails[key]}
              </p>
            ))}
          </div>
        </div>
      </div>
      {/* <div className="text-right">
        <p className="font-semibold text-foreground">
          For Universal Software
        </p>
        <p className="mt-4 text-blue-600">Authorised Signatory</p>
      </div> */}
    </div>
  );
};

export default InvoicePreviewPaymentSection;
